// //import React, { useState } from "react";
// //import { Link } from "react-router-dom";
// //import Logo from "../assets/whitelogo.png";
// //import Product3 from "../assets/products/3.png";
// //import HeroPoster from "../assets/indoor/hlc-residential-indoor-lighting.webp";
// import React from "react";
// import { Link } from "react-router-dom";
// import Logo from "../assets/whitelogo.png";
// import HeroVideo from "../assets/demo.mp4";


// export default function HeroSection() {
//   //const [videoFailed, setVideoFailed] = useState(false);

//   return (
//     <>
//       <section className="hlc-hero-video" aria-label="HLC Lighting">
//   <video
//   className="hlc-video"
//   src={HeroVideo}
//   autoPlay
//   loop
//   muted
//   playsInline
//   preload="auto"
// />

//         <div className="hlc-overlay"></div>

//         <div className="hlc-hero-content">
//           {/* ================== MOBILE VIEW ================== */}
//           <div className="hlc-mobile-view">
//             <div className="mobile-text-bg">
//               <div className="hlc-logo-wrap-mobile">
//                 <img
//                   src={Logo}
//                   alt="HLC Logo"
//                   className="hlc-logo-mobile"
//                 />
//               </div>

//               <h1 className="hlc-mobile-title">PREMIUM LED LIGHTING</h1>

//               <div className="hlc-mobile-buttons">
//                 <Link to="/about" className="hlc-btn hlc-btn--magenta">
//                   ABOUT US
//                 </Link>
//                 <Link to="/contact" className="hlc-btn hlc-btn--whatsapp">
//                   CONTACT US
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* ================== DESKTOP VIEW ================== */}
//           <div className="hlc-desktop-view">
//             <div className="hlc-logo-crown">
//               <img src={Logo} alt="HLC Logo" className="hlc-logo-img" />
//             </div>

//             <h1 className="hlc-title">PREMIUM LED LIGHTING</h1>

//             <div className="hlc-cta">
//             <Link to="/about" className="hlc-btn2 hlc-btn--magenta">
//                   ABOUT US
//               </Link>
//               <Link to="/contact" className="hlc-btn2 hlc-btn--whatsapp">
//                 CONTACT US
//               </Link>
//             </div>
//           </div>
//         </div>
//       </section>

//       <style>{`
//         html, body {
//           margin: 0;
//           padding: 0;
//           overflow-x: hidden;
//         }

//         :root {
//           --deep-blue: #35335b;
//           --royal-plum: #542757;
//           --magenta: #9b1f6c;
//         }

//         .hlc-hero-video {
//           position: relative;
//           width: 100vw;
//           left: 50%;
//           margin-left: -50vw;
//           max-width: 100vw;
//           height: 100vh;
//           overflow: hidden;
//           color: #fff;
//           font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
//         }

//         .hlc-video {
//           position: absolute;
//           inset: 0;
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .hlc-overlay {
//           position: absolute;
//           inset: 0;
//           z-index: 1;
//           pointer-events: none;
//           background:
//             linear-gradient(
//               135deg,
//               rgba(155, 31, 108, 0.70) 0%,
//               rgba(84, 39, 87, 0.60) 40%,
//               rgba(27, 15, 41, 0.75) 75%,
//               rgba(0, 0, 0, 0.85) 100%
//             ),
//             radial-gradient(
//               900px 380px at 12% 18%,
//               rgba(155, 31, 108, 0.25),
//               transparent 70%
//             );
//         }

//         .hlc-hero-content {
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%);
//           width: min(900px, 92%);
//           text-align: center;
//           z-index: 2;
//         }

//         /* ================== COMMON ================== */
//         .hlc-btn {
//           padding: 14px 32px;
//           font-size: 18px;
//           font-weight: 900;
//           letter-spacing: 0.5px;
//           text-decoration: none;
//           transition: 0.22s ease;
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           border: 2px solid transparent;
//           border-radius: 0; 
//           box-sizing: border-box;
//         }

//          .hlc-btn2 {
//           padding: 14px 32px;
//           font-size: 18px;
//           font-weight: 900;
//           letter-spacing: 0.5px;
//           text-decoration: none;
//           transition: 0.22s ease;
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           border: 2px solid transparent;
//           border-radius: 0; 
//           box-sizing: border-box;
//         }

//         .hlc-btn--magenta {
//           background: var(--magenta);
//           color: #fff;
          
//         }

//         .hlc-btn--magenta:hover {
//           background: rgba(40, 0, 55, 0.55);
//           color: #fff;
//         }

//         .hlc-btn--whatsapp {
//           background: lightgrey;
//           color: #2b2250;
//           border: 2px solid rgba(255, 255, 255, 0.5);
//         }

//         .hlc-btn--whatsapp:hover {
//           background: #ffffff;
//           color: #542757;
//           border-color: #ffffff;
//           transform: translateY(-2px);
//         }

//         /* ================== DESKTOP ================== */
//         .hlc-mobile-view {
//           display: none;
//         }

//         .hlc-desktop-view {
//           display: block;
//         }

//         .hlc-logo-crown {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-bottom: 16px;
//         }

//         .hlc-logo-img {
//           width: 300px;
//           height: 300px;
//           object-fit: contain;
//           filter:
//             brightness(1.15)
//             drop-shadow(0 0 30px rgba(155, 31, 108, 0.9))
//             drop-shadow(0 0 60px rgba(155, 31, 108, 0.5))
//             drop-shadow(0 4px 16px rgba(0, 0, 0, 0.6));
//         }

//         .hlc-title {
//           position: relative;
//           bottom: 80px;
//           font-weight: 900;
//           line-height: 1.05;
//           font-size: clamp(18px, 4.5vw, 40px);
//           text-transform: uppercase;
//           text-shadow: 0 2px 24px rgba(155, 31, 108, 0.45);
//           margin: 0;
//         }

//         .hlc-cta {
//           display: flex;
//           justify-content: center;
//           gap: 14px;
//           margin-top: -20px;p
//         }

//         /* ================== MOBILE ================== */
//         @media (max-width: 767px) {
//           .hlc-hero-video {
//             height: 100svh;
//           }

//           .hlc-desktop-view {
//             display: none;
//           }

//           .hlc-mobile-view {
//             display: block;
//           }

//           .hlc-hero-content {
//             width: 92%;
//             top: 50%;
//             left: 50%;
//             transform: translate(-50%, -50%);
//           }

//           .mobile-text-bg {
//             background: rgba(0, 0, 0, 0.5);
//             backdrop-filter: blur(6px);
//             padding: 28px 18px 24px;
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             align-items: center;
//             text-align: center;
//             min-height: 430px;
//             width: 100%;
//             box-sizing: border-box;
//               margin-top: 70px; 
//           }

//           .hlc-logo-wrap-mobile {
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             margin-top: 1px;   /* logo slightly down */
//             margin-bottom: 260px;
//             width: 100%;
//                       position:absolute

//           }

//           .hlc-logo-mobile {
//             width: 150px;
//             height: 150px;
//             object-fit: contain;
//             filter:
//               drop-shadow(0 0 20px rgba(155, 31, 108, 0.95))
//               drop-shadow(0 0 40px rgba(155, 31, 108, 0.5));
//           }

//           .hlc-mobile-title {
//             font-size: 28px;
//             font-weight: 900;
//             color: #fff;
//             margin: 0 0 24px 0;
//             text-transform: uppercase;
//             letter-spacing: 2px;
//             line-height: 1.2;
//             text-align: center;
//              margin-top: 60px; 
//           }

//           .hlc-mobile-buttons {
//             display: flex;
//             flex-direction: column;
//             gap: 12px;
//             width: 100%;
//             margin: 0;
//             padding: 0;
//             justify-content: center;
//             align-items: center;
//           }

//           .hlc-mobile-buttons .hlc-btn {
//             width: 100%;
//             padding: 14px 12px;
//             font-size: 17px;
//             border-radius: 0;
//           }
//         }
//       `}</style>
//     </>
//   );
// }

import React, { useLayoutEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useReducedMotion } from "framer-motion";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./HeroSection.css";

gsap.registerPlugin(ScrollTrigger);

/*
  HLC INTERACTIVE HERO
  ─────────────────────────────────────────────────────────────
  Two scroll-scrubbed frame sequences composited over a dark
  background via screen-blend (the pure-black video bg is knocked
  out automatically). Scene A: bulb cracks open. Scene B: it
  reassembles. Cursor drives layered parallax; scroll drives the
  reveal; the whole hero is pinned and the next section wipes up
  over its final frame.

  FRAMES  — put the WebP sequences in your public/ folder:
     public/hero/crack/s_000.webp ... s_119.webp        (120 frames)
     public/hero/reassemble/t_000.webp ... t_119.webp   (120 frames)
  (Both are in hlc-hero-frames-1280.zip — scene1-crack + scene2-reassemble.)

  ONE REQUIRED CHANGE IN Home.jsx:
     the wrapper must use overflow-x-clip, NOT overflow-x-hidden —
     hidden creates a scroll container that breaks the pin.
*/

const FRAME_COUNT = 120;
const CRACK_PATH = "/hero/crack/s_";        // + NNN + ".webp"
const REASM_PATH = "/hero/reassemble/t_";
const pad = (n) => String(n).padStart(3, "0");

/* The frame sequences are studio photos on a dark-but-not-pure-black
   backdrop, not real transparency — relying on mix-blend-mode:screen alone
   to hide that backdrop only works for exact rgb(0,0,0) pixels, so the
   photo's own near-black background shows up as a faint mismatched patch
   against the page's #0A0510. Key it out to real alpha once at load time
   (cheap: happens during the loading screen, not per animation frame) so
   only the genuinely bright bulb pixels remain. */
function keyOutBackground(img) {
  if (!img || !img.width) return img;
  const w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
  const cv = document.createElement("canvas");
  cv.width = w; cv.height = h;
  const ctx = cv.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);
  const data = ctx.getImageData(0, 0, w, h);
  const px = data.data;
  const lo = 14, hi = 34; // feather range so the cut edge isn't hard/jagged
  for (let i = 0; i < px.length; i += 4) {
    const lum = 0.2126 * px[i] + 0.7152 * px[i + 1] + 0.0722 * px[i + 2];
    if (lum <= lo) px[i + 3] = 0;
    else if (lum < hi) px[i + 3] = Math.round(px[i + 3] * ((lum - lo) / (hi - lo)));
  }
  ctx.putImageData(data, 0, 0);
  return cv;
}

/* ---------- progressive, deduplicated frame loading ----------
   Module-level (not component-local) so the cache survives React
   StrictMode's dev-only mount -> cleanup -> remount: the second
   invocation finds the same in-flight/resolved Promise per URL here
   and reuses it instead of firing a second network request. Stores the
   post-keyOutBackground canvas (what draw() actually renders), so that
   per-pixel processing isn't repeated either. */
const frameCache = new Map();
function loadFrame(url) {
  let p = frameCache.get(url);
  if (p) return p;
  p = new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(keyOutBackground(img));
    img.onerror = () => resolve(img);
    img.src = url;
  });
  frameCache.set(url, p);
  return p;
}

/* Loads `frames[i]` for i in [start, FRAME_COUNT) in the background,
   a few at a time (CONCURRENCY) instead of firing all of them at once,
   always picking whichever pending frame is currently closest to the
   live scrub position (state.f1 for crack, state.f2 for reassemble) so
   a fast scroller's target frames still arrive first. `frames` is
   mutated in place — draw() reads it fresh every tick, so no extra
   plumbing is needed to pick up newly-arrived frames. */
function loadRemaining({ crackUrls, reasmUrls, crack, reasm, crackStart, reasmStart, state, isKilled }) {
  const CONCURRENCY = 4;
  const pending = [];
  for (let i = crackStart; i < crackUrls.length; i++) pending.push({ seq: 0, i, url: crackUrls[i] });
  for (let i = reasmStart; i < reasmUrls.length; i++) pending.push({ seq: 1, i, url: reasmUrls[i] });

  let active = 0;

  const pickNext = () => {
    if (pending.length === 0) return null;
    let bestIdx = 0, bestDist = Infinity;
    for (let k = 0; k < pending.length; k++) {
      const job = pending[k];
      const target = job.seq === 0 ? state.f1 : state.f2;
      const dist = Math.abs(job.i - target);
      if (dist < bestDist) { bestDist = dist; bestIdx = k; }
    }
    return pending.splice(bestIdx, 1)[0];
  };

  const onFrameLoaded = (job) => (frame) => {
    active--;
    if (isKilled()) return;
    if (job.seq === 0) crack[job.i] = frame; else reasm[job.i] = frame;
    pump();
  };

  const pump = () => {
    if (isKilled()) return;
    while (active < CONCURRENCY) {
      const job = pickNext();
      if (!job) break;
      active++;
      loadFrame(job.url).then(onFrameLoaded(job));
    }
  };
  pump();
}

// ================= PHASE 1.5 — CLIENT REQUEST =================
// TEMPORARILY DISABLED: the Hero's reassemble phase (bulb re-forming +
// "50+ Years of Shine" copy swap). The crack/shatter phase remains the
// active Hero experience. All reassemble frames/code/assets below are
// fully preserved — this single flag is the only thing gating them,
// both in the scrub timeline (see boot()) and in the frame loader
// (see useLayoutEffect) so disabled reassemble frames are never
// requested over the network while this is off.
// To restore: set REASSEMBLE_ENABLED back to true.
const REASSEMBLE_ENABLED = false;

const ACT_TWO = {
  eyebrow: "High Lite Concern",
  headline: ["50+ Years", "of Shine"],
  sub: "Precision driver, LED array and heatsink — engineered together so the light holds its colour and output for the life of the fixture.",
};

export default function HeroSection() {
  const root = useRef(null);
  const seq1 = useRef(null);
  const seq2 = useRef(null);
  const reducedMotion = useReducedMotion();

  useLayoutEffect(() => {
    const REDUCED = reducedMotion;
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    let killed = false;
    let cleanupBoot = () => {};
    const ctx = gsap.context(() => {}, root);

    /* ---------- progressive frame loading ----------
       The crack sequence's files are numbered s_001..s_120 (1-indexed) on
       disk while reassemble is t_000..t_119 (0-indexed) — offset accounts
       for that so index 0 always resolves to a real file.

       Previously this fired all 240 frames at once via Promise.all and
       blocked boot() (ScrollTrigger setup, the scrub timeline, intro
       animation — everything) until every single one had loaded. That
       flooded the browser's connection pool and left the whole hero
       inert for however long 240 requests took.

       Now: load only a small initial buffer synchronously, boot the
       animation as soon as that's ready, then keep filling the rest of
       both arrays in place in the background at limited concurrency.
       draw() already no-ops on a not-yet-loaded frame (keeps showing the
       last one drawn), so a sparse array is safe to hand to boot() —
       nothing else about the rendering/scrub logic needs to change. */
    const crackUrls = Array.from({ length: FRAME_COUNT }, (_, i) => CRACK_PATH + pad(i + 1) + ".webp");
    const reasmUrls = Array.from({ length: FRAME_COUNT }, (_, i) => REASM_PATH + pad(i) + ".webp");
    const crack = new Array(FRAME_COUNT);
    const reasm = new Array(FRAME_COUNT);

    // Frame 0 of each is drawn immediately on boot; a handful more of the
    // crack sequence covers the first moments of scroll before the
    // background loader (prioritized by live scroll position, see
    // loadRemaining) catches up.
    // PHASE 1.5 — CLIENT REQUEST: while REASSEMBLE_ENABLED is false, no
    // reassemble frame (not even the initial buffer) is loaded at all —
    // the reassemble canvas never becomes visible with the timeline
    // gating below, so there is nothing for those bytes to buy.
    const INITIAL_CRACK = REDUCED ? 1 : 8;
    const INITIAL_REASM = !REDUCED && REASSEMBLE_ENABLED ? 2 : 0;
    const scrubState = { f1: 0, f2: 0, dirty: true };

    Promise.all([
      ...crackUrls.slice(0, INITIAL_CRACK).map((url, i) => loadFrame(url).then((f) => { crack[i] = f; })),
      ...reasmUrls.slice(0, INITIAL_REASM).map((url, i) => loadFrame(url).then((f) => { reasm[i] = f; })),
    ]).then(() => {
      if (killed) return;
      cleanupBoot = boot(crack, reasm, REDUCED, isMobile, ctx, scrubState);
      if (REDUCED) return;
      loadRemaining({
        crackUrls, reasmUrls, crack, reasm,
        crackStart: INITIAL_CRACK,
        // PHASE 1.5: reasmStart === FRAME_COUNT skips loadRemaining's
        // reassemble loop entirely (i starts at the array's own length),
        // so zero reassemble frames are ever requested while disabled.
        reasmStart: REASSEMBLE_ENABLED ? INITIAL_REASM : FRAME_COUNT,
        state: scrubState, isKilled: () => killed,
      });
    });

    return () => {
      killed = true;
      cleanupBoot();
      ctx.revert();
    };
  }, [reducedMotion]);

  /* ============================================================
     BOOT — everything after the frames are decoded
     ============================================================ */
  function boot(crack, reasm, REDUCED, isMobile, ctx, state) {
    const cleanups = [];
    const listen = (target, type, callback, options) => {
      target.addEventListener(type, callback, options);
      cleanups.push(() => target.removeEventListener(type, callback, options));
    };
    const cleanup = () => cleanups.forEach(dispose => dispose());
    let visible = true;
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; });
    observer.observe(root.current);
    cleanups.push(() => observer.disconnect());
    const tick = callback => {
      const frame = () => { if (visible && !document.hidden) callback(); };
      gsap.ticker.add(frame);
      cleanups.push(() => gsap.ticker.remove(frame));
    };
    const isTablet = window.matchMedia("(max-width: 1024px)").matches;
    const focusX = isMobile ? 0.5 : (isTablet ? 0.56 : 0.6);
    const focusY = 0.5;

    const makeRenderer = (canvas, frames) => {
      const c = canvas.getContext("2d", { alpha: false });
      let last = -1;
      const resize = () => {
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(canvas.clientWidth * dpr);
        canvas.height = Math.round(canvas.clientHeight * dpr);
        last = -1;
      };
      const draw = (index) => {
        const i = Math.max(0, Math.min(frames.length - 1, Math.round(index)));
        if (i === last) return;
        const img = frames[i];
        // Frame not loaded yet (progressive fill still in flight) — leave
        // `last` untouched so the same index is retried on the next tick
        // instead of getting permanently stuck once it does arrive.
        if (!img || !img.width) return;
        last = i;
        const cw = canvas.width, ch = canvas.height;
        // mobile plane is a dedicated 38vh band (see .l-plane mobile CSS) — needs margin so the image's own near-black background has room to key/blend out cleanly
        const fit = isMobile ? 0.66 : 0.82;
        const scale = Math.max(cw / img.width, ch / img.height) * fit;
        const w = img.width * scale, h = img.height * scale;
        const x = (cw - w) * focusX, y = (ch - h) * focusY;
        // Desktop relies on mix-blend-mode:screen to make this fill vanish into
        // .l-backdrop (pure black is a no-op under screen blend) — verified
        // that still works there. The confined mobile canvas band doesn't
        // blend through the same way (verified by sampling actual rendered
        // pixels: it renders as flat opaque black regardless), so on mobile
        // fill with the real void color directly instead of relying on a
        // blend that isn't taking effect — otherwise the margin around the
        // bulb is pure #000 next to the page's #0A0510, a small but visible
        // seam right at the canvas band's edge.
        c.fillStyle = isMobile ? "#0A0510" : "#000";
        c.fillRect(0, 0, cw, ch);
        c.drawImage(img, x, y, w, h);
      };
      return { resize, draw, count: frames.length, force: () => (last = -1) };
    };

    const r1 = makeRenderer(seq1.current, crack);
    const r2 = makeRenderer(seq2.current, reasm);

    const resizeAll = () => {
      r1.resize(); r2.resize(); state.dirty = true;
      if (REDUCED) r1.draw(0);
    };
    listen(window, "resize", resizeAll);
    resizeAll();

    r1.draw(0); r2.draw(0);
    // A static first frame needs neither a scrub timeline nor a particle loop.
    if (REDUCED) return cleanup;

    tick(() => {
      if (state.dirty) { r1.force(); r2.force(); state.dirty = false; }
      r1.draw(state.f1);
      r2.draw(state.f2);
    });

    ctx.add(() => {
      /* ---------- pointer parallax ---------- */
      const AMT = { bg: 3, rays: 8, plane: 12, glow: 20, particles: 32, copy: 4 };
      const pointer = { nx: 0, ny: 0, px: 0, py: 0, speed: 0 };
      const moveTo = (sel, d) => {
        const target = root.current.querySelector(sel);
        // Some decorative layers are intentionally disabled in this source.
        if (!target) return { x: () => {}, y: () => {} };
        return {
          x: gsap.quickTo(target, "x", { duration: d, ease: "power3.out" }),
          y: gsap.quickTo(target, "y", { duration: d, ease: "power3.out" }),
        };
      };
      const mBd = moveTo(".l-backdrop", 1.6);
      const mRays = moveTo(".l-rays", 1.0);
      const mPlane = moveTo(".l-plane", 0.8);
      const mCopy = moveTo(".l-copy", 1.1);
      const gX = gsap.quickTo(".l-glow", "x", { duration: 1.25, ease: "power3.out" });
      const gY = gsap.quickTo(".l-glow", "y", { duration: 1.25, ease: "power3.out" });
      const gO = gsap.quickTo(".l-glow", "opacity", { duration: 0.7, ease: "power2.out" });
      const tX = gsap.quickTo(".l-plane", "rotationX", { duration: 1, ease: "power3.out" });
      const tY = gsap.quickTo(".l-plane", "rotationY", { duration: 1, ease: "power3.out" });
      const rays = gsap.utils.toArray(".ray");
      const rRot = rays.map((el, i) =>
        gsap.quickTo(el, "rotation", { duration: 1.5 + i * 0.25, ease: "power2.out" })
      );
      let lx = 0, ly = 0;

      const onMove = (e) => {
        if (!visible || document.hidden) return;
        pointer.px = e.clientX; pointer.py = e.clientY;
        pointer.nx = e.clientX / window.innerWidth - 0.5;
        pointer.ny = e.clientY / window.innerHeight - 0.5;
        const dx = e.clientX - lx, dy = e.clientY - ly;
        pointer.speed = Math.min(1, Math.hypot(dx, dy) / 45);
        lx = e.clientX; ly = e.clientY;
        if (REDUCED) return;
        mBd.x(pointer.nx * AMT.bg); mBd.y(pointer.ny * AMT.bg);
        mRays.x(pointer.nx * AMT.rays); mRays.y(pointer.ny * AMT.rays);
        mPlane.x(pointer.nx * AMT.plane); mPlane.y(pointer.ny * AMT.plane);
        mCopy.x(pointer.nx * AMT.copy); mCopy.y(pointer.ny * AMT.copy);
        gX(pointer.px); gY(pointer.py); gO(0.5 + pointer.speed * 0.5);
        tY(pointer.nx * 5); tX(-pointer.ny * 3.5);
        rays.forEach((el, i) => rRot[i](pointer.nx * (8 - i * 1.5)));
      };
      listen(window, "pointermove", onMove, { passive: true });

      /* ---------- particles ---------- */
      const pCanvas = root.current.querySelector(".l-particles");
      const pCtx = pCanvas.getContext("2d");
      let parts = [];
      const seed = () => {
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        pCanvas.width = pCanvas.clientWidth * dpr;
        pCanvas.height = pCanvas.clientHeight * dpr;
        pCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
        const w = pCanvas.clientWidth, h = pCanvas.clientHeight;
        const n = isMobile ? 26 : 70;
        parts = Array.from({ length: n }, () => ({
          x: Math.random() * w, y: Math.random() * h, r: Math.random() * 1.5 + 0.5,
          vx: (Math.random() - 0.5) * 0.1, vy: -(Math.random() * 0.15 + 0.03),
          a: Math.random() * 0.4 + 0.12, tw: Math.random() * Math.PI * 2, depth: Math.random(),
        }));
      };
      seed();
      listen(window, "resize", seed);
      let progress = 0;
      const drawParts = () => {
        const w = pCanvas.clientWidth, h = pCanvas.clientHeight;
        pCtx.clearRect(0, 0, w, h);
        pCtx.globalCompositeOperation = "lighter";
        const boostP = 1 + progress * 1.6;
        for (const p of parts) {
          p.x += p.vx * boostP; p.y += p.vy * boostP; p.tw += 0.02;
          if (!REDUCED) {
            const dx = p.x - pointer.px, dy = p.y - pointer.py, d2 = dx * dx + dy * dy;
            if (d2 < 20000) { const f = (1 - d2 / 20000) * 1.8, d = Math.sqrt(d2) || 1; p.x += (dx / d) * f; p.y += (dy / d) * f; }
          }
          if (p.y < -10) { p.y = h + 10; p.x = Math.random() * w; }
          if (p.x < -10) p.x = w + 10; if (p.x > w + 10) p.x = -10;
          const ox = pointer.nx * AMT.particles * p.depth, oy = pointer.ny * AMT.particles * p.depth;
          const alpha = p.a * (0.6 + 0.4 * Math.sin(p.tw));
          pCtx.beginPath();
          pCtx.arc(p.x + ox, p.y + oy, p.r, 0, Math.PI * 2);
          pCtx.fillStyle = "rgba(255,220,240," + alpha.toFixed(3) + ")";
          pCtx.fill();
        }
        pCtx.globalCompositeOperation = "source-over";
      };
      tick(drawParts);

      /* ---------- magnetic CTAs ---------- */
      if (!REDUCED && !isMobile) {
        gsap.utils.toArray(".magnet").forEach((wrap) => {
          const sx = gsap.quickTo(wrap, "x", { duration: 0.5, ease: "power3.out" });
          const sy = gsap.quickTo(wrap, "y", { duration: 0.5, ease: "power3.out" });
          const R = 80;
          listen(window, "pointermove", (e) => {
            if (!visible || document.hidden) return;
            const b = wrap.getBoundingClientRect();
            const cx = b.left + b.width / 2, cy = b.top + b.height / 2;
            const dx = e.clientX - cx, dy = e.clientY - cy, dist = Math.hypot(dx, dy);
            if (dist < R + b.width / 2) {
              const pull = 1 - dist / (R + b.width / 2);
              sx(Math.max(-9, Math.min(9, dx * pull * 0.22)));
              sy(Math.max(-7, Math.min(7, dy * pull * 0.26)));
            } else { sx(0); sy(0); }
          }, { passive: true });
        });
      }

      /* ---------- intro ---------- */
      if (REDUCED) {
        gsap.set(".l-copy .act-1, .l-copy .act-1 *, .eyebrow, .sub.act-1, .cta-row > *, .badge-item, .rail, .cue", { clearProps: "all", opacity: 1, y: 0, yPercent: 0, filter: "none" });
      } else {
        gsap.timeline({ defaults: { ease: "expo.out" }, delay: 0.4 })
          .fromTo(".eyebrow", { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.9 }, 0.15)
          .fromTo(".act-1 .word > span", { yPercent: 118, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1.3, stagger: 0.06 }, 0.2)
          .fromTo(".sweep", { xPercent: -130, opacity: 0.9 }, { xPercent: 130, opacity: 0, duration: 1.5, ease: "power2.inOut" }, 0.25)
          .fromTo(".sub.act-1", { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 1 }, 0.65)
          .fromTo(".cta-row > *", { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.9, stagger: 0.08 }, 0.75)
          .fromTo(".badge-item", { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.8, stagger: 0.07 }, 0.9)
          .fromTo(".rail, .cue", { opacity: 0 }, { opacity: 1, duration: 0.8 }, 1.0);

        if (rays.length) gsap.to(rays, { opacity: "random(0.3,0.75)", duration: "random(3.5,7)", repeat: -1, yoyo: true, ease: "sine.inOut", stagger: { each: 0.5, from: "random" } });
      }

      /* ---------- scrub: crack -> reassemble, pinned, next section wipes up ---------- */
      const heroTl = gsap.timeline({
        scrollTrigger: {
          trigger: root.current,
          start: "top top",
          end: "bottom bottom",
          pin: root.current.querySelector(".stage"),
          pinSpacing: false,
          scrub: isMobile ? 0.35 : 0.7,
          invalidateOnRefresh: true,
          onUpdate: (st) => { progress = st.progress; },
        },
      });

      heroTl
        .to(state, { f1: r1.count - 1, ease: "none", duration: 0.42 }, 0)
        .fromTo(".l-plane", { scale: 1 }, { scale: 1.05, ease: "none", duration: 0.9 }, 0)
        .to(".l-backdrop", { scale: 1.08, ease: "none", duration: 0.9 }, 0)
        .to(".cue", { opacity: 0, ease: "power1.out", duration: 0.05 }, 0);

      // ================= PHASE 1.5 — CLIENT REQUEST =================
      // TEMPORARILY DISABLED: dissolve crack -> reassemble + copy swap.
      // Untouched from the original implementation — restore by setting
      // REASSEMBLE_ENABLED = true above.
      if (REASSEMBLE_ENABLED) {
        heroTl
          .to(state, { f2: r2.count - 1, ease: "none", duration: 0.5 }, 0.42)
          .to(".seq1", { opacity: 0, ease: "power2.inOut", duration: 0.12 }, 0.44)
          .fromTo(".seq2", { opacity: 0 }, { opacity: 1, ease: "power2.inOut", duration: 0.12 }, 0.44)
          .to(".act-1", { opacity: 0, ease: "power1.inOut", duration: 0.1 }, 0.44)
          .fromTo(".act-2", { opacity: 0 }, { opacity: 1, ease: "power1.inOut", duration: 0.1 }, 0.5);
      }

      /* copy clears near the end so the frozen crack/shatter frame holds
         (originally: "so the frozen reassembled bulb holds") */
      heroTl.to(".l-copy, .rail", { opacity: 0, ease: "power1.in", duration: 0.1 }, 0.86);

      ScrollTrigger.refresh();
    });
    return cleanup;
  }

  return (
    <section className="hlc-hero" ref={root} aria-label="HLC premium LED lighting">
      <div className="stage">
        <div className="scene">
          <div className="l-backdrop" />
          {/* Temporarily disabled — light-beam rays
          <div className="l-rays">
            <span className="ray ray--1" />
            <span className="ray ray--2" />
            <span className="ray ray--3" />
          </div>
          */}
          <div className="l-plane">
            <canvas className="seq seq1" ref={seq1} />
            <canvas className="seq seq2" ref={seq2} style={{ opacity: 0 }} />
          </div>
          <div className="l-glow" />
          <canvas className="l-particles" />

          <div className="l-copy">
            <h1 className="sr-only">Premium LED lighting by High Lite Concern</h1>
            <p className="eyebrow">High Lite Concern</p>

            <div className="headline acts" aria-hidden="true">
              <div className="act-1">
                <span className="sweep" />
                <span className="word"><span>Premium</span></span>
                <span className="word word--accent"><span>LED</span></span>
                <span className="word"><span>Lighting</span></span>
              </div>
              <div className="act-2">
                {ACT_TWO.headline.map((w, i) => (
                  <span key={w} className={"word" + (i === 1 ? " word--accent" : "")}>
                    <span>{w}</span>
                  </span>
                ))}
              </div>
            </div>

            <div className="subs">
              <p className="sub act-1">
                Engineered luminaires for homes, offices, retail and industry —
                designed for the light, built for the decade.
              </p>
              <p className="sub act-2">{ACT_TWO.sub}</p>
            </div>

            <div className="cta-row">
              <span className="magnet">
                <Link to="/about" className="btn btn--solid">
                  About us
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                </Link>
              </span>
              <span className="magnet">
                <Link to="/contact" className="btn btn--ghost">
                  Contact us
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                </Link>
              </span>
            </div>
          </div>

          <div className="badges">
            <div className="badge-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 2l3 6 6 .5-4.5 4 1.5 6-6-3.3-6 3.3 1.5-6L3 8.5 9 8z" /></svg><div><div className="bt">Premium</div><div className="bs">Quality</div></div></div>
            <div className="badge-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 2l8 3v6c0 5-3.4 9-8 11-4.6-2-8-6-8-11V5z" /><path d="M9 12l2 2 4-4" /></svg><div><div className="bt">2 Year</div><div className="bs">Warranty</div></div></div>
            <div className="badge-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M11 3C7 5 5 8 5 12a7 7 0 0014 0c0-1.5-.5-3-1.5-4.5C16 9 14 9 13 7c-.8-1.5-1-2.7-2-4z" /></svg><div><div className="bt">Energy</div><div className="bs">Efficient</div></div></div>
            <div className="badge-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M13 2L4 14h7l-2 8 9-12h-7z" /></svg><div><div className="bt">Surge</div><div className="bs">Protection</div></div></div>
          </div>

          <div className="rail"><span>Indoor · Outdoor · Commercial · Industrial</span></div>
          <div className="cue"><span>Scroll to explore</span><span className="mouse" /></div>
        </div>
      </div>
    </section>
  );
}
